import { defineMessages } from 'react-intl';

export default defineMessages({
  infoNewUserHeader: {
    description: 'UserManagementModal Info header when creating a new user',
    defaultMessage:
      'Add a user login to your account below. An email will be sent to the email address specified with instructions and a <b>temporary password</b> to login.',
    id: '0xHxKn',
  },
  infoEditUserHeader: {
    description: 'UserManagementModal Info header when editing exiting user info',
    defaultMessage: 'Update basic user information below.',
    id: '0MQv88',
  },
  username: {
    description: 'username input label',
    defaultMessage: 'Username',
    id: 'xp+IBa',
  },
  name: {
    description: 'full name input label',
    defaultMessage: 'Full Name',
    id: 'RkoZ9n',
  },
  email: {
    description: 'email input label',
    defaultMessage: 'Email',
    id: 'NIsGlU',
  },
  password: {
    description: 'password input label',
    defaultMessage: 'Password',
    id: 'tw/Z8k',
  },
  confirmPassword: {
    description: 'confirm password input label',
    defaultMessage: 'Confirm Password',
    id: 'MiRX6Q',
  },
  allowLogin: {
    description: 'allow user to login checkbox label',
    defaultMessage: 'Allow this user to log in(deselecting will deactivate and log the user out).',
    id: 'pcOz40',
  },
  userCreated: {
    description: 'user created label',
    defaultMessage: 'User Created:',
    id: 'KQo+fL',
  },
  lastLoggedIn: {
    description: 'last logged in label',
    defaultMessage: 'Last Logged in:',
    id: 'ftCBF9',
  },
  isActive: {
    description: 'user account active label',
    defaultMessage: 'This user account is active',
    id: 'RMagP3',
  },
  isInactive: {
    description: 'user account inactive label',
    defaultMessage: 'This user account is inactive',
    id: 'HAMQ9B',
  },
  lockedOutMessage: {
    description: 'indicates that the user was locked out from their account',
    defaultMessage: 'This user account has been locked out due to 5 failed login attempts.',
    id: 'zbHRGY',
  },
  unlockSuccessMessage: {
    description: 'indicates unlocking a user account succeeded',
    defaultMessage: 'User account unlocked!',
    id: 'Lh/1qC',
  },
  unlockFailureMessage: {
    description: 'indicates that the user was locked out from their account ',
    defaultMessage: 'Error unlocking account. Please try again.',
    id: 'aZ711Q',
  },
  unlockAccount: {
    description: 'unlock account button text',
    defaultMessage: 'Unlock Account',
    id: '4FbIXy',
  },
  emailWarning: {
    description: 'Warning shown when changing a user email',
    defaultMessage:
      'Changing the email address will <b>disable all email functionality for this account</b> until it is verified. A verification email will be sent to the new email address.',
    id: 'uym6dK',
  },
  understand: {
    description: 'text for button to acknowledge email warning',
    defaultMessage: 'I understand',
    id: 'MXstzs',
  },
  headsUp: {
    description: 'email warning header text',
    defaultMessage: 'Heads up!',
    id: 'l7d+6Z',
  },
  pleaseContactSupport: {
    description: 'email warning tooltip text',
    defaultMessage: 'Please contact support to change this email address.',
    id: 'gTHlee',
  },
  changePassword: {
    description: 'change password link text',
    defaultMessage: 'Change Password',
    id: 'eyGxfc',
  },
  inventoryWarehouse: {
    description: 'Inventory warehouse field label',
    defaultMessage: 'Warehouse',
    id: '66zxKA',
  },
  selectWarehouse: {
    description: 'Select warehouse placeholder',
    defaultMessage: 'Select',
    id: 'HfJK7Q',
  },
});
